<script>
    export default {
        functional: true,

        props: {
            inline: {type: Boolean, default: false},
            column: {type: [Boolean, Object], default: () => ({})},
            reverse: {type: Boolean, default: false},
            justify: {type: [String, Object], default: () => ({})},
            align: {type: [String, Object], default: () => ({})},
            wrap: {type: [Boolean, String, Object], default: () => ({})},
        },

        render: function(createElement, context) {
            let {inline, reverse, justify, align, wrap, column} = context.props;
            let classes = [];

            // change to object
            if (typeof justify !== "object") {
                justify = {default: justify};
            }
            if (typeof align !== "object") {
                align = {default: align};
            }
            if (typeof wrap !== "object") {
                wrap = {default: wrap};
            }
            if (typeof column !== "object") {
                column = {default: column};
            }

            // merge with default value
            justify = {default: 'start', ...justify};
            align = {default: 'center', ...align};
            wrap = {default: false, ...wrap};
            column = {default: false, ...column};

            let applyObject = (prefix, object, prepare) => {
                for (let [breakpoint, value] of Object.entries(object)) {
                    let _prefix = prefix;

                    if (breakpoint !== 'default') {
                        _prefix += `-${breakpoint}`;
                    }

                    if (prepare instanceof Function) {
                        value = prepare(value);
                    }
                    classes.push(`${_prefix}-${value}`);
                }
            };

            // apply props
            classes.push(inline ? 'd-inline-flex' : 'd-flex');
            applyObject('justify-content', justify);
            applyObject('align-items', align);
            applyObject('flex', wrap, value => value === true ? 'wrap' : (value === false ? 'nowrap' : value));
            applyObject('flex', column, value => `${value ? 'column' : 'row'}${reverse ? '-reverse' : ''}`);

            return createElement('div', {class: classes, on: context.listeners, ...context.data}, context.children);
        },
    };
</script>